<template>
  <div class="tranche-ca">
    <!--<Popup v-if="store.dataDisplay.popupTranchesCaCreate"></Popup>-->
    <Modal title="Création d'une nouvelle tranche CA" :open="modalOpen" @close="modalOpen = false;">
      <table class="table table-responsive">
        <tr>
          <th>Libelle</th>
          <th>Valeur Min</th>
          <th>Valeur Max</th>
          <th></th>

        </tr>
        <tr>
          <td><input class="form-control" id="libelle" type="text" v-model="newTrancheCa.Libelle" /></td>
          <td><input class="form-control" id="valueMin" type="number" min=0 v-model="newTrancheCa.ValueMin" /></td>
          <td><input class="form-control" id="valueMax" type="number" min=0 v-model="newTrancheCa.ValueMax" /></td>
          <td><button type="button" id="btn-save" class="btn" v-on:click="createTrancheCa()">Créer</button></td>
        </tr>
      </table>

    </Modal>
    <h2>Paramétrage des tranches CA</h2>
    <br />
    <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold text-primary">Personnalisation des tranches CA</h6>
      </div>
      <!-- Card Body -->
      <div class="p-3">
        <table class="table table-responsive">
          <tr>
            <th>Id</th>
            <th>Libelle</th>
            <th>Valeur Min</th>
            <th>Valeur Max</th>
            <th></th>
            <th></th>

          </tr>
          <tr v-for="(tranche, index) in trancheCa" :key="tranche.Id">
            <td>{{ tranche.Id }}</td>
            <td><input class="form-control" :id="`libelle-${index}`" type="text" v-model="tranche.Libelle" /></td>
            <td><input class="form-control" :id="`valueMin-${index}`" type="number" min=0 v-model="tranche.ValueMin" /></td>
            <td><input class="form-control" :id="`valueMax-${index}`" type="number" min=0 v-model="tranche.ValueMax" /></td>
            <td><button type="button" :id="`btn-save-${index}`" class="btn-save" v-on:click="updateTrancheCa(tranche)">Enregistrer</button></td>
            <td><button type="button" :id="`btn-suppr-${index}`" class="btn-suppr" v-on:click="deleteTrancheCa(tranche)">Supprimer</button></td>
          </tr>
        </table>
        <button type="button" class="btn-add" v-on:click="modalOpen = true;">Ajouter</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from "@/components/Modal";
  import { apiFetch, apiPost } from "@/utils";
  import { initTrancheCa } from "@/utils/adminMapsMixin";

  export default {
    name: 'TrancheCa',
    components: { Modal },
    data() {
      return {
        trancheCa: [],
        modalOpen: false,
        newTrancheCa: {
          Libelle: "",
          ValueMin: "",
          ValueMax: ""
        }
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        initTrancheCa().then(res => {
          this.trancheCa = res;
        })
      },
      createTrancheCa() {
          apiPost("maps/trancheCa/create?libelle=" + this.newTrancheCa.Libelle + "&valueMin=" + this.newTrancheCa.ValueMin + "&valueMax=" + this.newTrancheCa.ValueMax)
          .then(e => {
            alert("Création effectuée avec succés");
            this.modalOpen = false;
            this.newTrancheCa = {
              Libelle: "",
              ValueMin: "",
              ValueMax: ""
            }
            this.initData();
            console.log(e);
          })
          .catch(e => {
            alert("Erreur de création");
            console.log(e);
          });
      },
      updateTrancheCa(trancheCa) {
        apiPost("maps/trancheCa/update/byid?id=" + trancheCa.Id + "&libelle=" + trancheCa.Libelle + "&valueMin=" + trancheCa.ValueMin + "&valueMax=" + trancheCa.ValueMax)
          .then(res => {
            this.initData();
            alert("Sauvegarde effectuée avec succés");
            console.log(res);
          })
          .catch(e => {
            alert("Erreur de sauvegarde");
            console.log(e);
          });
      },

      deleteTrancheCa(trancheCa) {
        apiPost("maps/trancheCa/delete/byid?id=" + trancheCa.Id)
          .then(e => {
            this.initData();
            alert("Suppression effectuée avec succés");
            console.log(e);
          })
          .catch(e => {
            alert("Erreur de suppression");
            console.log(e);
          });
      },

      popupCreateTrancheCa() {
        mutations.switchFilters("messagePopupTranchesCaCreate");
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.tranche-ca {
    width: 76%;
  }

  #btn-add {
    margin-left: 2%;
    margin-bottom: 2%;
  }

  .card .table {
      display: block;
      padding: 0 !important;
  }
  .card .table tr {
      padding: 6px 0;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/TrancheCa.vue